export const isReviewable = (reservation) => {
  return reservation?.checkOutStatus === 'checked_out' || reservation?.status === 'completed';
};

export const buildReservationWhatsAppMessage = ({ companyName, reservationId, serviceName }) => {
  const companyLabel = companyName || 'a empresa';
  const serviceLabel = serviceName || 'o serviço';
  return `Olá ${companyLabel}! Quero fechar minha reserva para ${serviceLabel}. Número da reserva: ${reservationId}`;
};
